import React from "react";
import { LOGOS, LOCATION } from "../lib/brand";
import { Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer
      id="footer"
      data-testid="site-footer"
      className="relative border-t border-[#27272A] bg-[#050505] py-16"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <a
            href="#top"
            data-testid="footer-logo-link"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("top");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="inline-block"
          >
            <img
              src={LOGOS.wordmark}
              alt="Kung Fu TCG"
              className="h-14 w-auto max-w-[220px] object-contain"
            />
          </a>
          <p className="mt-4 max-w-xs text-sm text-[#A1A1AA]">
            Card shop, board games & boba. The dojo for your next move.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">Visit</div>
          <p className="mt-3 text-sm text-[#F5F5DC]">
            <span className="block font-display tracking-wider text-[#E11D2A]">
              {LOCATION.name}
            </span>
            {LOCATION.address}
            <br />
            {LOCATION.city}
          </p>
          <a
            href={`tel:${LOCATION.phone}`}
            data-testid="footer-phone-link"
            className="mt-2 inline-block text-sm text-[#A1A1AA] hover:text-[#E11D2A]"
          >
            {LOCATION.phone}
          </a>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#E11D2A]">Follow</div>
          <div className="mt-3 flex gap-3">
            {[
              { Icon: Instagram, href: "#", label: "instagram" },
              { Icon: Facebook, href: "#", label: "facebook" },
              { Icon: Twitter, href: "#", label: "twitter" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                data-testid={`footer-${label}-link`}
                className="flex h-10 w-10 items-center justify-center border border-[#27272A] text-[#F5F5DC] transition-colors hover:border-[#E11D2A] hover:text-[#E11D2A]"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-[#27272A] px-4 pt-6 text-xs text-[#A1A1AA] sm:px-6 lg:px-8">
        © {new Date().getFullYear()} Kung Fu TCG. All rights reserved.
      </div>
    </footer>
  );
}
